import React from 'react';
import s from './AboutUs.module.css';
import images from '../../assets/index';
import { useMediaQuery } from 'react-responsive';
const Hero = () => {
  const isMobile = useMediaQuery({ query: '(max-width:767px)' });
  const isDesktop = useMediaQuery({ query: '(min-width:1440px)' });
  return (
    <div className={s.section}>
      <div className="container">
        <div className={s.flex}>
          <div className={s.leftSide}>
            <img
              className={s.img}
              src={
                isMobile
                  ? images.aboutUs
                  : isDesktop
                  ? images.aboutUsDesk
                  : images.aboutTablet
              }
            />
          </div>
          <div className={s.rightSide}>
            <div className={s.titleBox}>
              <img src={images.aboutUs_logo} className={s.aboutUs_logo} />
              <h1 className={s.mainTitle}>About ArtistsHub</h1>
            </div>
            <p className={s.description}>
              At ArtistsHub, our mission is to connect music lovers with the
              artists they adore. We strive to create a vibrant community where
              discovering new music is as enjoyable as listening to it.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Hero;
